export default "__VITE_ASSET__Cgk8GTGb__"